import { resolveI18n } from "../../../commons/services/Translation"

export const LabelWidth = (i18n) => {
  return resolveI18n({ i18n, ko: 200, en: 250, vi: 250 })
}

